import { UserDecksList } from "src/components/NewComponents/Flashcards/UserDecks/UserDecksList";

export default function UserDecksContainer() {
	return <UserDecksList />;
}
